var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFourthCardSecond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2585_29616)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 81,
    height: 81,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 10.5,
    width: 80,
    height: 80,
    rx: 11.5,
    stroke: "#D7DEFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5 50.5C50.5 46.0731 54.0887 42.4844 58.5156 42.4844C62.9425 42.4844 66.5312 46.0731 66.5312 50.5C66.5312 54.9269 62.9425 58.5156 58.5156 58.5156C54.0887 58.5156 50.5 54.9269 50.5 50.5Z",
    fill: "#1ABCFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4688 66.5313C34.4688 62.1043 38.0575 58.5156 42.4844 58.5156H50.5V66.5313C50.5 70.9582 46.9113 74.5469 42.4844 74.5469C38.0575 74.5469 34.4688 70.9582 34.4688 66.5313Z",
    fill: "#0ACF83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5 26.4531V42.4844H58.5156C62.9425 42.4844 66.5312 38.8957 66.5312 34.4688C66.5312 30.0418 62.9425 26.4531 58.5156 26.4531H50.5Z",
    fill: "#FF7262"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4688 34.4688C34.4688 38.8957 38.0575 42.4844 42.4844 42.4844H50.5V26.4531H42.4844C38.0575 26.4531 34.4688 30.0418 34.4688 34.4688Z",
    fill: "#F24E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4688 50.5C34.4688 54.9269 38.0575 58.5156 42.4844 58.5156H50.5V42.4844H42.4844C38.0575 42.4844 34.4688 46.0731 34.4688 50.5Z",
    fill: "#A259FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2585_29616",
    x: 0,
    y: 0,
    width: 105,
    height: 105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2585_29616"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2585_29616",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourthCardSecond);
export default __webpack_public_path__ + "static/media/fourth-card-second.b33b03fe69aa0fcb8ba7de79f3a38b9d.svg";
export { ForwardRef as ReactComponent };